import axiosInstance from "./axiosInstance";

// ================= TYPES =================

export interface PaginationParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
}

// ================= DASHBOARD =================
export const getDashboardStats = () =>
  axiosInstance.get("/admin/dashboard");

// ================= AUTH =================

// 📲 Send OTP
export const sendOtp = (mobile: string) =>
  axiosInstance.post("/auth/send-otp", { mobile });

// ✅ Verify OTP
export const verifyOtp = (mobile: string, otp: string) =>
  axiosInstance.post("/auth/verify-otp", { mobile, otp });

// ================= USERS =================

// 👥 Get all users
export const getUsers = (params?: PaginationParams) =>
  axiosInstance.get("/admin/users", { params });

// 🚫 Update user status
export const updateUserStatus = (id: string, status: string) =>
  axiosInstance.patch(`/admin/users/${id}/status`, { status });

// ================= BOOKINGS =================

// 📅 Get all bookings
export const getBookings = (params?: PaginationParams) =>
  axiosInstance.get("/admin/bookings", { params });

// 🔄 Update booking status
export const updateBookingStatus = (id: string, status: string) =>
  axiosInstance.patch(`/admin/bookings/${id}/status`, { status });

// ================= PAYMENTS =================

// 💰 Get all payments
export const getPayments = (params?: PaginationParams) =>
  axiosInstance.get("/admin/payments", { params });

// ================= SUPPORT =================

// 🎫 Get support tickets
export const getSupportTickets = (params?: PaginationParams) =>
  axiosInstance.get("/admin/support", { params });

// 🔄 Update ticket status
export const updateTicketStatus = (id: string, status: string) =>
  axiosInstance.patch(`/admin/support/${id}/status`, { status });

// ================= NOTIFICATIONS =================

// 🔔 Get notifications
export const getNotifications = () =>
  axiosInstance.get("/admin/notifications");

// 🔢 Unread count
export const getUnreadCount = () =>
  axiosInstance.get("/admin/notifications/unread-count");

// 📩 Mark as read
export const markAsRead = (id: string) =>
  axiosInstance.patch(`/admin/notifications/${id}/read`);

// ================= SERVICES =================

// 📋 Get services (mobile wala API reuse)
export const getServices = () =>
  axiosInstance.get("/services");

// ✏️ Update service (admin)
export const updateService = (id: string, data: any) =>
  axiosInstance.put(`/admin/services/${id}`, data);